module.exports = __webpack_public_path__ + "media/images/svg/decoration-eef396726c485bec542464bc0d59191f.svg";